var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ConfigProvider } from "@context/config";
import ReactDOM from "react-dom";
import { configPropsSchema } from "@schema/index";
import { App } from "./components";
import { SHIPPING_PLACE, SHIPPING_SLOT } from "./constants";
import "./styles.css";
export function render(renderConfig) {
    try {
        if (!("deliveryAppConfig" in window)) {
            throw "deliveryAppConfig is missing";
        }
        var config = __assign(__assign({}, renderConfig), window.deliveryAppConfig);
        var _a = configPropsSchema.validateSync(config), containerId = _a.containerId, recharge = _a.recharge, rest = __rest(_a, ["containerId", "recharge"]);
        var properties = {};
        var c = __assign({}, rest);
        if (recharge) {
            // convert f**king Recharge data structure
            for (var _i = 0, _b = recharge.properties; _i < _b.length; _i++) {
                var property = _b[_i];
                if (property.name === SHIPPING_SLOT ||
                    property.name === SHIPPING_PLACE) {
                    properties[property.name] = parseInt(property.value);
                }
                else {
                    properties[property.name] = property.value;
                }
            }
            c["recharge"] = __assign(__assign({}, recharge), { properties: properties });
        }
        // Tailwind is using this as a wrapper class to increase the specificity
        document.body.setAttribute("id", "dapp");
        ReactDOM.render(_jsx(ConfigProvider, __assign({ config: c }, { children: _jsx(App, {}, void 0) }), void 0), document.getElementById(containerId));
    }
    catch (error) {
        console.error("dapp: " + error);
    }
}
